var icon = require('vue-svgicon')
icon.register({
  'linearicons/users': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M18.5 18h-11c-.827 0-1.5-.673-1.5-1.5 0-.048.011-1.19.924-2.315.525-.646 1.241-1.158 2.128-1.522 1.071-.44 2.4-.662 3.948-.662s2.876.223 3.948.662c.887.364 1.603.876 2.128 1.522.914 1.125.924 2.267.924 2.315 0 .827-.673 1.5-1.5 1.5zM7 16.503a.5.5 0 0 0 .5.497h11a.5.5 0 0 0 .5-.497c-.001-.035-.032-.895-.739-1.734-.974-1.157-2.793-1.768-5.261-1.768s-4.287.612-5.261 1.768c-.707.84-.738 1.699-.739 1.734zM13 11c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm0-7c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zM4.5 18h-3C.673 18 0 17.327 0 16.5c0-.037.008-.927.663-1.8.378-.505.894-.904 1.533-1.188.764-.34 1.708-.512 2.805-.512.179 0 .356.005.527.014a.5.5 0 0 1-.053.999 9.1 9.1 0 0 0-.473-.012c-3.894 0-3.997 2.379-4 2.503a.5.5 0 0 0 .5.497h3a.5.5 0 0 1 0 1zM5 12c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/generated_svg_icons/linearicons/users.js